import React from 'react';
import Avatar from '@atlaskit/icon/core/person-avatar';
import InboxIcon from '@atlaskit/icon/core/inbox';
import { SECTION_ITEM_YOUR_WORK } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
import { MENU_ID_YOUR_WORK } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useFormattedMessageAndIcon } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import { jiraHomeRoute } from '@atlassian/jira-router-routes-jira-home-routes/src/jiraHomeRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

const JIRA_HOME_PATH = jiraHomeRoute.path;

const analytics = {
	actionSubjectId: SECTION_ITEM_YOUR_WORK,
	itemId: 'yourWork',
	level: 1,
	// Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
	isInMore: false,
};

export const YourWork = () => {
	const { formattedMessage: formattedMessageOld, icon: iconOld } = useFormattedMessageAndIcon(
		messages.yourWork,
		InboxIcon,
	);

	const { formattedMessage, icon } = useFormattedMessageAndIcon(messages.forYou, Avatar);

	return (
		<Nav4MenuLinkItem
			analytics={analytics}
			elemBefore={fg('blu-6576_migrate_to_platform_customisation') ? icon : iconOld}
			href={JIRA_HOME_PATH}
			menuId={MENU_ID_YOUR_WORK}
		>
			{fg('blu-6576_migrate_to_platform_customisation') ? formattedMessage : formattedMessageOld}
		</Nav4MenuLinkItem>
	);
};
